var NEED_DELETE_FIELDS, ProfilesForm;

import FieldList from 'trunks/vue/admin/components/fields/list/fieldable.js';

import FormableMixin from 'trunks/vue/admin/compositions/formables/mixin.js';

import {
  FIELD_GROUPS
} from 'trunks/vue/admin/components/fields/constants.js';

NEED_DELETE_FIELDS = ['Field::Organization', 'Field::Member', 'Field::Calculation', 'Field::Location', 'Field::Detail', 'Field::Rating', 'Field::File'];

export default ProfilesForm = Vue.extend({
  mixins: [FormableMixin],
  components: {
    'field-list': FieldList
  },
  props: {
    type: {
      type: String,
      default: 'form'
    }
  },
  computed: {
    constantFieldGroups: function() {
      return _.reduce(FIELD_GROUPS, function(memo, item) {
        var child, options;
        child = _.filter(item.options, function(option) {
          return _.contains(NEED_DELETE_FIELDS, option.type);
        });
        options = _.difference(item.options, child);
        memo.push({
          'options': options
        });
        return memo;
      }, []);
    },
    fieldsEmpty: function() {
      return !this.form.fields.length;
    }
  },
  template: `<div class="formable-view">
  <div class="formable-empty-content" v-if="fieldsEmpty">
    <i class="form-empty-icon slp-ip-dropbox"></i>
    <div class="form-empty-text">暂无，请点击右侧按钮添加</div>
  </div>
  <div class="formable-edit-view">
    <field-list :fields='form.fields'
                :fieldable='form'
                :fieldGroupOptions='constantFieldGroups'
                :disabledFieldLayout='true'
                @fieldLengthChanged='fieldsLengthChangedFunc'
                ref='fieldsView'>
      <div class="list-group" slot="user-settings" slot-scope="{ field }">
        <div class="list-item clickable"
              @click="toggleSetting(field, 'register_writed')">
          <div class="tip">
            <i :class='[ field.settings.register_writed ? "slp-check" : "slp-empty" ]'></i>
          </div>
          <div class="content force-no-wrap">{{ _getUserSettingTitle('register_writed') }}</div>
        </div>
        <div class="list-item clickable"
              @click="toggleSetting(field, 'explicit')">
          <div class="tip">
            <i :class='[ field.settings.explicit ? "slp-check" : "slp-empty" ]'></i>
          </div>
          <div class="content force-no-wrap">{{ _getUserSettingTitle('explicit') }}</div>
        </div>
        <div class="list-item clickable"
              @click="toggleSetting(field, 'enable_modify')">
          <div class="tip">
            <i :class='[ field.settings.enable_modify ? "slp-check" : "slp-empty" ]'></i>
          </div>
          <div class="content force-no-wrap">{{ _getUserSettingTitle('enable_modify') }}</div>
        </div>
      </div>
    </field-list>
    <div class="formable-actions" ref='formableActions'>
      <div class="slp-tooltip right" data-title="添加表项">
        <div class="action-item clickable" @click='addNewField'>
          <i class="slp-plus-circle"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="formable-outer-actions justify-box">
    <div class="right-actions">
      <button @click="save" :disabled='fieldsEmpty'>保存</button>
    </div>
  </div>
</div>`,
  methods: {
    addNewField: function() {
      return this.$refs.fieldsView.addNewField();
    },
    fieldsLengthChangedFunc: function() {
      return this.$emit('fieldsLengthChanged');
    },
    save: function() {
      return Skylark.Libs.Ajax.put('/admin/user_profile/schema', {
        contentType: "application/json; charset=UTF-8",
        data: {
          schema: {
            fields_attributes: this.form.toJSON().fields_attributes
          }
        },
        success: function() {
          Skylark.Bridge.newAlertify('保存成功', {
            type: 'success'
          });
          return Turbolinks.visit();
        },
        error: function() {
          return Skylark.Bridge.newAlertify('保存失败', {
            type: 'error'
          });
        }
      });
    },
    toggleSetting: function(field, key) {
      return field.settings[key] = !field.settings[key];
    },
    _getUserSettingTitle: function(user_setting) {
      return Skylark.Helpers.translate(`field.userSettings.${user_setting}`);
    }
  }
});
